<a class="TEXTO_AYUDA" [href]="urlAyuda" target="_blank">
  <em class="bi bi-question-circle" style="font-size: 16px; -webkit-text-stroke: 1px;"></em>&nbsp;¿Necesitas ayuda?
</a>